// Amounts as an office's price forms hold them (what a product costs, what
// sending an order costs): typed as a person writes a price, kept in minor
// units, one per currency.

// What a field holds as the amount it stands for, in minor units: null when
// it is empty, undefined when it is not an amount.
export function amountOf(text, minorUnit) {
  const typed = String(text).trim().replace(',', '.');
  if (typed === '') return null;
  const major = Number(typed);
  if (!Number.isFinite(major) || major < 0) return undefined;
  const minor = Math.round(major * (10 ** minorUnit));
  return Number.isSafeInteger(minor) ? minor : undefined;
}

// What a field shows for an amount that is kept: nothing where there is none.
export const shownAmount = (amountMinor, currency) => (
  amountMinor === null ? '' : (amountMinor / (10 ** currency.minorUnit)).toFixed(currency.minorUnit));

// The fields of a form of prices against what is kept: the amounts that
// changed (null for one that was emptied), and the fields that hold no amount.
export function readAmounts(currencies, typed, stored) {
  const changed = {};
  const wrong = [];
  for (const currency of currencies) {
    const amount = amountOf(typed[currency.code], currency.minorUnit);
    if (amount === undefined) wrong.push(currency.code);
    else if (amount !== stored[currency.code]) changed[currency.code] = amount;
  }
  return { changed, wrong };
}
